import { IdoLinkingsParameter } from 'src/models/ido';
import { IdoListViewModel } from 'src/models/idoList';

import { Callback } from 'src/util/query/models/Callback';

import {
	SetIdoRelationsForAnIdoIdoInstanceListViewModelLoadingPayload,
	SetIdoRelationsForAnIdoIdoInstanceListViewModelPayload,
	SetIdoRelationsForAnIdoIdoInstanceListViewModelResultCountPayload,
	SetIdoRelationsPaginationPayload,
} from '../interfaces';
import { Pagination } from '../types';

export class GetTheIdoRelationsListviewModelAndDataQueryCallback extends Callback<IdoListViewModel> {
	public constructor(
		private readonly idoInstanceId: string,
		private readonly idoLinkingsParameter: IdoLinkingsParameter,
		private readonly getIdoRelationsPagination: (idoRecordIdentifier: string) => Pagination,
		private readonly setIdoRelationsForAnIdoIdoInstanceListViewModel: (
			payload: SetIdoRelationsForAnIdoIdoInstanceListViewModelPayload
		) => void,
		private readonly setIdoRelationsForAnIdoIdoInstanceListViewModelLoading: (
			payload: SetIdoRelationsForAnIdoIdoInstanceListViewModelLoadingPayload
		) => void,
		private readonly setIdoRelationsForAnIdoIdoInstanceListViewModelResultCount: (
			payload: SetIdoRelationsForAnIdoIdoInstanceListViewModelResultCountPayload
		) => void,
		private readonly setIdoRelationsPagination: (payload: SetIdoRelationsPaginationPayload) => void
	) {
		super();
	}

	private get idoRecordIdentifier(): string {
		return `${this.idoInstanceId}-${this.idoLinkingsParameter.idoId}-${this.idoLinkingsParameter.instanceId}`;
	}

	failureCallbackFunction = (): void => {
		this.setIdoRelationsForAnIdoIdoInstanceListViewModelLoading({
			idoRecordIdentifier: this.idoRecordIdentifier,
			loading: false,
		});
	};

	successCallbackFunction = (successResponse: IdoListViewModel): void => {
		const listViewModel = successResponse.results[0];
		const totalCount = listViewModel?.totalCount ?? 0;

		if (listViewModel !== undefined) {
			this.setIdoRelationsForAnIdoIdoInstanceListViewModel({
				idoRecordIdentifier: this.idoRecordIdentifier,
				idoRelationsForAnIdoIdoInstanceListViewModel: listViewModel,
			});
		}

		this.setIdoRelationsForAnIdoIdoInstanceListViewModelResultCount({
			idoRecordIdentifier: this.idoRecordIdentifier,
			idoRelationsForAnIdoIdoInstanceListViewModelResultCount: totalCount,
		});

		this.setIdoRelationsPagination({
			idoRecordIdentifier: this.idoRecordIdentifier,
			pagination: {
				...this.getIdoRelationsPagination(this.idoRecordIdentifier),
				rowsNumber: totalCount,
			},
		});

		this.setIdoRelationsForAnIdoIdoInstanceListViewModelLoading({
			idoRecordIdentifier: this.idoRecordIdentifier,
			loading: false,
		});
	};
}
